// -- External libraries
import { splitProps } from 'solid-js'
import { Dynamic } from 'solid-js/web'
import { A } from '@solidjs/router'

import { useLinkAtomComponentController } from './link-atom-component-controller.js'
import './link-atom-component.scss'

export default function LinkAtomComponent (props) {
    const {
        mergedProps,
    } = useLinkAtomComponentController(props)
    const requiredAttributes = [
        'external', 'disabled', 'inline',
    ]
    const [
        requestAttributes,
        styles,
        attributes,
    ] = splitProps(mergedProps, requiredAttributes, ['class', 'classList'])

    /*
     * A FUNCTION, not a value computed once during setup. `props` is reactive:
     * read at setup, `disabled` was sampled a single time and a link that later
     * became disabled kept its enabled class forever — and the same read is what
     * `solid/reactivity` flags on this file. Called from JSX, every read below
     * lands in a tracked scope and the class string follows the props.
     */
    const rootClasses = () => {
        const classes = ['link-atom-component']
        if (styles.class) classes.push(styles.class)
        // Body-copy links carry a permanent underline; see the modifier's note
        // in the stylesheet for why this is opt-in rather than the default.
        if (requestAttributes.inline) classes.push('link-atom-component--inline')
        if (requestAttributes.disabled) classes.push('link-atom-component--disabled')
        return classes.join(' ')
    }

    return (
        <Dynamic class={rootClasses()} classList={styles.classList} component={requestAttributes.external ? 'a' : A} {...attributes}>
            {attributes.children}
        </Dynamic>
    )
}
